var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * A geometria das colunas de uma tabela, decidida pelo `TableModel` e desenhada pela
 * view.
 *
 * A view NAO decide largura nem onde uma coluna presa encosta: ela desenha o que esta
 * aqui, mede a largura que o conteudo pede quando falta alguma, e avisa o que o leitor
 * fez com a borda. A conta e da apresentacao, e qualquer outra view faria a mesma.
 */
let TableLayoutScope = class TableLayoutScope extends Scope {
    constructor() {
        super(...arguments);
        /**
         * A largura de cada coluna visivel: a que o leitor escolheu, ou a medida. Coluna que
         * falta aqui e coluna que a view ainda precisa medir.
         */
        this.widths = {};
        /** Onde cada coluna presa a esquerda encosta: a soma das presas antes dela. */
        this.offsets = {};
        /** Quantas das primeiras colunas ficam presas a esquerda. */
        this.pinned = 0;
        /** A largura do bloco preso inteiro - onde a rolagem encaixa a primeira coluna livre. */
        this.pinnedWidth = 0;
        /** As colunas cuja borda o leitor pode arrastar. */
        this.resizable = {};
        /**
         * Ja houve uma medida COM dado. Antes dela, a medida que existe pode ser so a do
         * cabecalho (tabela vazia), e a primeira linha que chegar pede outra. Mora aqui, e nao
         * na view, para sobreviver a view desmontar e voltar: voltar a tela nao mede de novo.
         */
        this.measuredWithRows = false;
        /** A view mediu a largura que o conteudo pede, por campo - com ou sem linhas na tabela. */
        this.onMeasure = () => undefined;
        /** O leitor terminou de arrastar a borda de `field`. */
        this.onResize = () => undefined;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "widths", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "offsets", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "pinned", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "pinnedWidth", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "resizable", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TableLayoutScope.prototype, "measuredWithRows", void 0);
TableLayoutScope = __decorate([
    Observable
], TableLayoutScope);
export { TableLayoutScope };
//# sourceMappingURL=table-layout.scope.js.map